module.exports = __webpack_public_path__ + "abel-trotter-portfolio-picture.3ae3a875a5bf6dce780e.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/assets/img/abel-trotter-portfolio-picture.jpg
// module id = ../../../../../src/assets/img/abel-trotter-portfolio-picture.jpg
// module chunks = main